module.exports = __webpack_public_path__ + "img/symbol_6.5c0f4817.png";